import React, { useEffect, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import JsBarcode from "jsbarcode";

// ✅ QR code with logo overlay
const QRWithLogo = ({ value, size = 200, logoSrc = "../../../bica/megmart_icon.svg" }) => {
    const logoSize = Math.round(size * 0.26);

    return (
        <div style={{ position: "relative", display: "inline-block" }}>
            <QRCodeCanvas
                value={String(value)}
                size={size}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
                includeMargin
            />
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: logoSize,
                    height: logoSize,
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#fff",
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <img
                    src={logoSrc}
                    alt="MEGAMART Logo"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
            </div>
        </div>
    );
};

const StickerPrint = ({ order }) => {
    const barcodeRef = useRef(null);
    const trackingUrl = `https://megamart.co.ke/track/${order.order_number}`;

    useEffect(() => {
        if (barcodeRef.current && order?.order_number) {
            JsBarcode(barcodeRef.current, order.order_number, {
                format: "CODE128",
                width: 2,
                height: 40,
                displayValue: true,
                fontSize: 12,
                margin: 0,
            });
        }
    }, [order?.order_number]);

    const handlePrintSticker = () => {
        const printContent = document.getElementById("sticker-content");
        const printWindow = window.open("", "PRINT", "height=600,width=400");

        if (printWindow && printContent) {
            printWindow.document.write(`
        <html><head><title>Print Sticker</title></head><body>
          ${printContent.innerHTML}
        </body></html>
      `);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => printWindow.print(), 800); // allow canvas to render
        }
    };

    return (
        <div>
            {/* Hidden container for print */}
            <div
                id="sticker-content"
                style={{ position: "absolute", left: "-9999px", visibility: "hidden" }}
            >
                <div
                    style={{
                        width: 300,
                        padding: 16,
                        fontFamily: "Arial, sans-serif",
                        border: "1px solid #ccc",
                        backgroundColor: "#fff",
                        color: "#111",
                    }}
                >
                    {/* Logo + Company Info */}
                    <div style={{ textAlign: "center", marginBottom: 8 }}>
                        <img src="../../../bica/megmart_icon.svg" alt="MEGAMART" width={120} />
                        <h2 style={{ fontSize: 16, margin: "4px 0" }}>MEGAMART Online Shopping</h2>
                        <p style={{ fontSize: 12, margin: 0 }}>Phone: +254 118182959</p>
                    </div>

                    {/* Order Info */}
                    <div style={{ fontSize: 12, lineHeight: 1.4 }}>
                        <p><strong>Order:</strong> {order.order_number}</p>
                        <p><strong>Customer:</strong> {order.customer_name}</p>
                        <p><strong>Phone:</strong> {order.customer_phone}</p>
                        <p><strong>Address:</strong> {order.delivery_address}</p>
                    </div>

                    {/* QR Code */}
                    <div style={{ textAlign: "center", marginTop: 10 }}>
                        <QRWithLogo value={trackingUrl} />
                        <p style={{ fontSize: 10 }}>{trackingUrl}</p>
                    </div>

                    {/* Barcode */}
                    <div style={{ textAlign: "center", marginTop: 8 }}>
                        <canvas ref={barcodeRef} />
                        <p style={{ fontSize: 10 }}>Scan for Warehouse Processing</p>
                    </div>
                </div>
            </div>

            {/* Print Button */}
            <button
                onClick={handlePrintSticker}
                style={{
                    marginTop: 16,
                    backgroundColor: "#059669",
                    color: "#fff",
                    padding: "8px 16px",
                    borderRadius: 4,
                    border: "none",
                    cursor: "pointer",
                }}
            >
                Print Sticker
            </button>
        </div>
    );
};

export default StickerPrint;
